import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingOverlay = ({ message = 'Processing...', subMessage = 'Please wait' }) => {
    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
            <div className="bg-white rounded-2xl shadow-2xl p-8 flex flex-col items-center gap-4 animate-slideUp">
                <div className="relative">
                    {/* Outer spinning ring */}
                    <div className="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin border-t-blue-600"></div>
                    {/* Inner pulsing circle */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <Loader2 size={24} className="text-blue-600 animate-pulse" />
                    </div>
                </div>
                <div className="text-center">
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{message}</h3>
                    <p className="text-sm text-gray-500">{subMessage}</p>
                </div>
            </div>
        </div>
    );
};

export default LoadingOverlay;
